// extracted by mini-css-extract-plugin
module.exports = {"list":"StudentHistoryList_list__Jt3m8","planDisabled":"StudentHistoryList_planDisabled__1-ycs"};